import _ from 'lodash';
import moment from 'moment';

export const loadPlayerWidgets = (tournamentId, teamId, playerId) => {
    return fetch(`https://ss2.si-ab.com/players/${playerId}/profile`)
        .then(response => response.json())
        .then(player => {
            return Promise.all([
                player,
                player.team &&
                    fetch(`https://ss2.si-ab.com/teams/${player.team.id}`).then(response => response.json()),
                player.nationalTeam &&
                    fetch(`https://ss2.si-ab.com/teams/${player.nationalTeam.id}`).then(response =>
                        response.json(),
                    ),
            ])
                .then(([player, team, nationalTeam]) => {
                    return Promise.all([
                        player,
                        team,
                        nationalTeam,
                        team &&
                            team.id &&
                            fetch(`https://ss2.si-ab.com/tournaments/${team.mainTournamentId}`).then(response =>
                                response.json(),
                            ),
                    ]);
                })
                .then(([player, team, nationalTeam, tournament]) => {
                    const data = {
                        player,
                        team,
                        nationalTeam,
                        tournament,
                    };
                    return {
                        data,
                        widgets: preparePlayerWidgets(data),
                    };
                });
        });
};

export const preparePlayerWidgets = data => {
    const { player, tournament, team } = data;
    return [
        // TABLE
        ...info(player, tournament, team, 'BIO'),
        ...profiles(player, tournament, 'STATS'),
    ];
};

export const info = (player, tournament, team, category) => {
    return ['PlayerProfileOpta', 'PlayerProfileAdvSMWidget'].map(wid => ({
        id: wid,
        props: {
            playerId: player.id,
            tournamentId: tournament.id,
            teamId: team.id,
        },
        spec: {
            social: true,
            widgetGroup: wid,
        },
        category: [category],
        key: `bio-${wid}-${player.id}`,
    }));
};

export const profiles = (player, tournament, category) => {
    return [
        'PlayerSeasonProfileX3V1',
        'PlayerSeasonProfileX3V2',
        'PlayerSeasonProfileX3V3',
        'PlayerSeasonProfileX3V4',
        'PlayerSeasonProfileX5V1',
        'PlayerSeasonProfileX5V2',
        'PlayerSeasonProfileX5V3',
        'PlayerSeasonProfileX5V4',
    ].map(wid => ({
        id: wid,
        props: {
            playerId: player.id,
            tournamentId: tournament.id,
        },
        spec: {
            social: true,
            widgetGroup: wid,
        },
        category: [category],
        key: `stats-${wid}-${player.id}`,
    }));
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/loaders/player.js
 **/